module.exports = __webpack_public_path__ + "static/media/collegebg.c5a29436.png";